import { Helmet } from 'react-helmet-async';

function ContactPage({ lang }) {
  const langAttr = lang === 'zh' ? 'zh-CN' : lang === 'ko' ? 'ko' : 'en';

  const titles = {
    en: 'Contact Us',
    zh: '联系我们',
    ko: '문의하기',
  };

  const subtitles = {
    en: 'Visit Bunny Boy Massage',
    zh: '访问 Bunny Boy Massage',
    ko: 'Bunny Boy Massage 방문',
  };

  const bookTitle = {
    en: 'Book a Session',
    zh: '预约服务',
    ko: '예약하기',
  };

  const bookSubtitle = {
    en: 'Contact us directly for the best experience',
    zh: '直接联系我们获得最佳体验',
    ko: '최고의 경험을 위해 직접 연락주세요',
  };

  const addressLabel = {
    en: 'ADDRESS',
    zh: '地址',
    ko: '주소',
  };

  const hoursLabel = {
    en: 'OPENING HOURS',
    zh: '营业时间',
    ko: '영업시간',
  };

  const hoursValue = {
    en: 'Open Daily: 10:00 AM - 00:00 AM',
    zh: '每天营业: 10:00 AM - 00:00 AM',
    ko: '매일 영업: 10:00 AM - 00:00 AM',
  };

  const directionsLabel = {
    en: 'HOW TO GET HERE',
    zh: '如何到达',
    ko: '오시는 길',
  };

  const directionsValue = {
    en: '5-minute walk from Bangkok BTS Phra Khanong Station',
    zh: '距曼谷BTS Phra Khanong站步行5分钟',
    ko: '방콕 BTS 프라카농역에서 도보 5분',
  };

  const ctaText = {
    en: 'Contact Us Now',
    zh: '立即联系我们',
    ko: '지금 문의하기',
  };

  return (
    <>
      <Helmet>
        <html lang={langAttr} />
        <meta name="google-site-verification" content="oqrrPJxHE-glI4a2-kLFEyROX0bIiQgU7FxBcaITmrA" />
        <title>Contact | Bunny Boy Massage Bangkok</title>
        <meta name="description" content="Contact Bunny Boy Massage in Sukhumvit, Bangkok. Call, LINE, or WhatsApp us to book your session." />
        <meta property="og:title" content="Contact | Bunny Boy Massage Bangkok" />
        <meta property="og:description" content="Contact Bunny Boy Massage in Sukhumvit, Bangkok. Call, LINE, or WhatsApp us to book your session." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://www.bunnyboymassage.com/og-contact.jpg" />
        <meta property="og:url" content={`https://www.bunnyboymassage.com${lang === 'zh' ? '/zh' : lang === 'ko' ? '/ko' : ''}/contact`} />
        <meta property="og:site_name" content="Bunny Boy Massage" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Contact | Bunny Boy Massage Bangkok" />
        <meta name="twitter:description" content="Contact Bunny Boy Massage in Sukhumvit, Bangkok." />
        <meta name="twitter:image" content="https://www.bunnyboymassage.com/og-contact.jpg" />
      </Helmet>

      <section className="pt-28 pb-10 sm:pt-36 sm:pb-[60px] bg-dark min-h-screen">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-4">
            <p className="font-montserrat text-xs tracking-[0.3em] uppercase" style={{ color: '#b9a1fc' }}>{titles[lang]}</p>
          </div>
          <div className="text-center mb-14">
            <h1 className="font-playfair text-4xl sm:text-5xl font-bold" style={{ color: '#b9a1fc' }}>{subtitles[lang]}</h1>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16">
            <div className="space-y-8">
              <div>
                <h2 className="font-playfair text-2xl sm:text-3xl font-bold mb-2" style={{ color: '#b9a1fc' }}>{bookTitle[lang]}</h2>
                <p className="font-montserrat text-lg" style={{ color: '#ddddde' }}>{bookSubtitle[lang]}</p>
              </div>

              <div className="space-y-5">
                <a href="https://wa.me/66811103766" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 group">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden" style={{ border: '1px solid #856ec7' }}>
                    <img src="/icon-whatsapp.png" alt="WhatsApp" className="w-7 h-7 object-contain" />
                  </div>
                  <span className="font-montserrat text-lg group-hover:underline" style={{ color: '#ddddde' }}>WhatsApp: 081-110-3766 (Click)</span>
                </a>

                <a href="https://line.me/ti/p/z2MKz54daM" target="_blank" rel="noopener noreferrer" className="flex items-center space-x-4 group">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0 overflow-hidden" style={{ border: '1px solid #856ec7' }}>
                    <img src="/icon-line.png" alt="LINE" className="w-7 h-7 object-contain" />
                  </div>
                  <span className="font-montserrat text-lg group-hover:underline" style={{ color: '#ddddde' }}>LINE ID: bunnyboybkk (Click)</span>
                </a>

                <a href="tel:081-110-3766" className="flex items-center space-x-4 group">
                  <div className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0" style={{ border: '1px solid #856ec7' }}>
                    <svg className="w-5 h-5" style={{ color: '#b9a1fc' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" /></svg>
                  </div>
                  <span className="font-montserrat text-lg group-hover:underline" style={{ color: '#ddddde' }}>Mobile: 081-110-3766</span>
                </a>
              </div>

              <a
                href="https://line.me/ti/p/z2MKz54daM"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-10 py-4 font-montserrat text-sm tracking-widest uppercase transition-all duration-300 hover:bg-gold hover:text-dark-secondary text-center"
                style={{ border: '1px solid #856ec7', color: '#b9a1fc' }}
              >
                {ctaText[lang]}
              </a>
            </div>

            <div className="space-y-8">
              <div>
                <h3 className="font-montserrat text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#b9a1fc' }}>{addressLabel[lang]}</h3>
                <p className="font-montserrat text-lg" style={{ color: '#ddddde' }}>3/15, 4th Floor, Sukhumvit 71 Rd,<br />Khwaeng Phra Khanong Nuea, Watthana,<br />Bangkok 10110</p>
              </div>

              <div className="w-full h-[280px] sm:h-[320px]" style={{ border: '1px solid #856ec7' }}>
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1937.8!2d100.5936575!3d13.7141704!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x30e29fc1448bad8b%3A0x783ac84a11658233!2sBunny%20Boy%20Massage!5e0!3m2!1sen!2sth!4v1234567890"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Bunny Boy Massage Location"
                />
              </div>

              <div>
                <h3 className="font-montserrat text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#b9a1fc' }}>{hoursLabel[lang]}</h3>
                <p className="font-montserrat text-lg" style={{ color: '#ddddde' }}>{hoursValue[lang]}</p>
              </div>

              <div>
                <h3 className="font-montserrat text-xs tracking-[0.3em] uppercase mb-3" style={{ color: '#b9a1fc' }}>{directionsLabel[lang]}</h3>
                <p className="font-montserrat text-lg" style={{ color: '#ddddde' }}>{directionsValue[lang]}</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ContactPage;
